module.exports = __webpack_public_path__ + "img/chevronLeft.0bed22cd.svg";